/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-globals */
export interface IDefaultReturn {
  masked: string;
  unmasked: string;
}

const defaultReturn = (masked: any, unmasked: any): IDefaultReturn => ({
  masked,
  unmasked,
});

export const hiddenCardNumber = (card: string) => {
  let hideNum = [];
  for (let i = 0; i < card.length; i++) {
    if (i <= 3) {
      hideNum.push(card[i]);
    } else if (i === 12) {
      hideNum.push(card[i]);
    } else if (i >= 4 && i < card.length - 3) {
      hideNum.push("●");
    } else {
      hideNum.push(card[i]);
    }
  }
  return hideNum.join("");
};
export const hiddenCardNumberTwo = (
  str: any,
  index: number,
  lastIndex: number,
  chr: string
) => {
  if (index > str.length - 1) return str;
  return str.substring(0, index) + chr + str.substring(lastIndex);
};

export const currencyMask = (param: number | string): string => {
  if (!param) return "0,00";

  let value = "";

  if (typeof param === "number") {
    param = param.toFixed(2);
  }

  if (String(param).includes(".") || String(param).includes(",")) {
    value = String(param);
  } else {
    value = `${String(param)}.00`;
  }

  value = String(value).replace(".", "").replace(",", "");

  const v = `${(Number(value) / 100).toFixed(2)}`.split(".");

  let m = v[0]
    .split("")
    .reverse()
    .join("")
    .match(/.{1,3}/g) as String[];

  if (m === null) m = [];

  for (let i = 0; i < m.length; i += 1)
    m[i] = `${m[i].split("").reverse().join("")}.`;

  const r = m.reverse().join("");

  const masked = `${r.substring(0, r.lastIndexOf("."))},${v[1]}`;

  return masked;
};

export const moneyMask = (value = 0.0) =>
  new Intl.NumberFormat("pt-BR", {
    currency: "BRL",
    style: "currency",
  }).format(value);

export const creditCardUnmask = (value = ""): string =>
  value.replace(".", "").replace(".", "").replace(".", "").replace(".", "");

export const dateUnmask = (value = ""): string => value.replace(/\D/gim, "");

export const cepUnmask = (value = ""): string => value.replace(/\D/gim, "");

export const cpfUnmask = (value = ""): string => value.replace(/\D/gim, "");

export const currencyUnmasked = (value = ""): number =>
  Number(value.replace(".", "").replace(",", "."));

export const phoneUnmask = (value = ""): string =>
  value.replace(/\D/gim, "").replace(/\D/g, "");

export const cpfMask = (value = ""): string => {
  return value
    .replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, "$1.$2") // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1"); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export const hideCpf = (value: string): string => {
  let cpfFormat = cpfMask(value);
  let hideCpf = [];
  for (let i = 0; i < cpfFormat.length; i++) {
    if (i <= 3) {
      hideCpf.push(cpfFormat[i]);
    } else if (i === 7) {
      hideCpf.push(cpfFormat[i]);
    } else if (i >= 4 && i < cpfFormat.length - 3) {
      hideCpf.push("*");
    } else {
      hideCpf.push(cpfFormat[i]);
    }
  }
  return hideCpf.join("");
};

export const creditCardMask = (value = ""): IDefaultReturn => {
  const newValue = value.replace(/\D/g, "");
  const sizeValue = value.length;

  if (sizeValue <= 9)
    return defaultReturn(
      newValue.replace(/(\d{4})(\d{1,4})/g, "$1.$2"),
      creditCardUnmask(value)
    );

  if (sizeValue <= 14)
    return defaultReturn(
      newValue.replace(/(\d{4})(\d{4})(\d{1,4})/g, "$1.$2.$3"),
      creditCardUnmask(value)
    );

  return defaultReturn(
    newValue.replace(/(\d{4})(\d{4})(\d{4})(\d{1,4})/g, "$1.$2.$3.$4"),
    creditCardUnmask(value)
  );
};

export const dateMask = (value = ""): IDefaultReturn => {
  const newValue = value.replace(/\D/g, "").replace(/^(\d{2})(\d)/g, "$1/$2");

  if (newValue.length > 4)
    return defaultReturn(
      newValue.replace(/(\d{2})(\d{1,2})/, "$1/$2"),
      dateUnmask(value)
    );
  return defaultReturn(newValue, dateUnmask(value));
};

export const phoneMask = (value = ""): IDefaultReturn => {
  const maskedValue = value
    .replace(/\D/g, "")
    .replace(/^(\d{2})(\d)/g, "($1) $2")
    .replace(/(\d)(\d{4})$/, "$1-$2");

  return defaultReturn(maskedValue, phoneUnmask(value));
};

export const cepMask = (value = ""): IDefaultReturn => {
  const maskedValue = value
    .replace(/\D/g, "")
    .replace(/^([\d]{2})\.*([\d]{3})-*([\d]{3})/, "$1$2-$3");

  return defaultReturn(maskedValue, cepUnmask(value));
};

export const hourMinSecMask = (value = ""): IDefaultReturn => {
  const maskedValue = value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1:$2")
    .replace(/(\d{2})(\d{1,2})/, "$1:$2")
    .replace(/(:\d{2})\d+?$/, "$1");

  return defaultReturn(maskedValue, cepUnmask(value));
};

export const numericMask = (value = ""): string => value.replace(/\D/g, "");

export const hideEmailMask = (value = ""): string => {
  const [prefix] = value.split("@");

  const prefixToHide = prefix.slice(3);

  return value.replace(prefixToHide, "*".repeat(prefixToHide.length));
};

export const emailMask = (value = ""): string =>
  value
    .replace(/[^a-zA-Z0-9-_.@]/g, "")
    .trim()
    .toLowerCase();

export const nameMask = (value = "") => {
  return value
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^\w\s]/gi, "")
    .replace(/[0-9]/g, "")
    .replace(/ +(?= )/g, "");
};
